import { toast } from "sonner";

export const reorderInto = (cart, lines, shop, t) => {
  const ok = lines.filter((l) => shop.priceMap[l.item_code] && shop.byCode[l.item_code]);
  cart.addMany(ok.map((l) => ({ item_code: l.item_code, qty_boxes: l.qty_boxes, uom: l.uom || "box" })));
  toast.success(t("home.reordered", { n: ok.length }));
  if (ok.length < lines.length) toast.warning(t("home.reorderSkipped", { n: lines.length - ok.length }));
  return ok.length;
};
